/**
 * @license Copyright (c) 2022, Memo.ph by Globe Telecom. All rights reserved.
 */
import React from 'react';
import Status from '../../../layouts/status/Status';
import TableBodyCell from '../../../layouts/table/TableBodyCell';
import TableRow from '../../../layouts/table/TableRow';
import { Memo } from '../../../models/Memo';
import { getDateString } from '../../../utils/date/Date';
import { DatatableComponentProps } from '../datatable/Datatable';

const HistoryMemosTableBody = (props: DatatableComponentProps) => {
    if (!props.memos || !props.headers) {
        return <TableRow />;
    }
    return (
        <>
            {props.memos!.map((_memo: Memo, index) => {
                const memo = _memo as unknown as Record<string, any>;
                return (
                    <TableRow key={index} navigateTo={`/memos/history/${memo.memo_id}`}>
                        {props.headers!.map((header: any) => {
                            if (header.key === 'date_last_modified') {
                                return (
                                    <TableBodyCell key={header.key}>
                                        {getDateString(memo.date_last_modified)}
                                    </TableBodyCell>
                                );
                            }
                            if (header.key === 'memo_status') {
                                return (
                                    <TableBodyCell key={header.key}>
                                        <Status type={memo.memo_status.toLowerCase()} />
                                    </TableBodyCell>
                                );
                            }

                            const field = memo.find(header.key);

                            if (field) {
                                return <TableBodyCell key={memo[header.key] + `${index}`}>{field.value}</TableBodyCell>;
                            }

                            return <TableBodyCell key={memo[header.key]}>{memo[header.key]}</TableBodyCell>;
                        })}
                    </TableRow>
                );
            })}
        </>
    );
};

export default HistoryMemosTableBody;
